import * as Types from '../../../../graphql/types';

import { CalendarMonthString, CalendarDateTimeString, CalendarDateString } from "scalars";
import { gql } from '@apollo/client';
import { PageInfoFragmentDoc } from '../../../../graphql/fragments/pageInfo.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PagedPrepaidFragment = { __typename?: 'Prepaid', id: any, description?: string | null, status: Types.PrepaidStatus, date: CalendarDateString, startDate?: CalendarDateString | null, endDate?: CalendarDateString | null, expenseRecognitionMethod?: Types.ExpenseRecognitionMethod | null, ledgerCoaKey: string, total?: { __typename?: 'Money', amount: string } | null, vendor?: { __typename?: 'Vendor', id: string, name: string } | null };

export type PrepaidRollforwardTotalsFragment = { __typename?: 'PrepaidRollforwardDataTotals', amount: { __typename?: 'Money', amount: string }, opening: { __typename?: 'Money', amount: string }, prepaid: { __typename?: 'Money', amount: string }, closing: { __typename?: 'Money', amount: string }, recognized: { __typename?: 'Money', amount: string }, recognizedEndPeriod: { __typename?: 'PrepaidRollforwardDataPeriod', period: string, total: { __typename?: 'Money', amount: string } } };

export type PrepaidRollforwardByCoaFragment = { __typename?: 'PrepaidRollforwardDataByCoa', ledgerCoaKey: string, totals: { __typename?: 'PrepaidRollforwardDataTotals', amount: { __typename?: 'Money', amount: string }, opening: { __typename?: 'Money', amount: string }, prepaid: { __typename?: 'Money', amount: string }, closing: { __typename?: 'Money', amount: string }, recognized: { __typename?: 'Money', amount: string }, recognizedEndPeriod: { __typename?: 'PrepaidRollforwardDataPeriod', period: string, total: { __typename?: 'Money', amount: string } } } };

export type GetPrepaidsQueryVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  filterBy?: Types.InputMaybe<Types.PrepaidFilterBy>;
  sortBy?: Types.InputMaybe<Types.PrepaidSortOrder>;
  page?: Types.InputMaybe<Types.PageInput>;
}>;


export type GetPrepaidsQuery = { __typename?: 'Query', company?: { __typename?: 'Company', id: string, prepaids: { __typename?: 'PrepaidPaginator', items: Array<{ __typename?: 'Prepaid', id: any, description?: string | null, status: Types.PrepaidStatus, date: CalendarDateString, startDate?: CalendarDateString | null, endDate?: CalendarDateString | null, expenseRecognitionMethod?: Types.ExpenseRecognitionMethod | null, ledgerCoaKey: string, total?: { __typename?: 'Money', amount: string } | null, vendor?: { __typename?: 'Vendor', id: string, name: string } | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, total?: number | null } } } | null };

export type PrepaidSchedulePreviewItemsFragment = { __typename?: 'PrepaidExpenseRecognitionSchedulePreviewItems', period: CalendarMonthString, expenseIncurred: string, cumulativeExpense: string, prepaidExpense: string };

export type PrepaidExpenseRecognitionSchedulePreviewQueryVariables = Types.Exact<{
  input: Types.PrepaidExpenseRecognitionSchedulePreviewInput;
}>;


export type PrepaidExpenseRecognitionSchedulePreviewQuery = { __typename?: 'Query', prepaidExpenseRecognitionSchedulePreview: { __typename?: 'PrepaidExpenseRecognitionSchedulePreview', scheduleItems: Array<{ __typename?: 'PrepaidExpenseRecognitionSchedulePreviewItems', period: CalendarMonthString, expenseIncurred: string, cumulativeExpense: string, prepaidExpense: string }> } };

export type PrepaidExpenseRecognitionSchedulePreviewByCriteriaQueryVariables = Types.Exact<{
  input: Types.PrepaidExpenseRecognitionSchedulePreviewByCriteriaInput;
}>;


export type PrepaidExpenseRecognitionSchedulePreviewByCriteriaQuery = { __typename?: 'Query', prepaidExpenseRecognitionSchedulePreviewByCriteria: { __typename?: 'PrepaidExpenseRecognitionSchedulePreview', scheduleItems: Array<{ __typename?: 'PrepaidExpenseRecognitionSchedulePreviewItems', period: CalendarMonthString, expenseIncurred: string, cumulativeExpense: string, prepaidExpense: string }> } };

export type CreatePrepaidMutationVariables = Types.Exact<{
  input: Types.CreatePrepaidInput;
}>;


export type CreatePrepaidMutation = { __typename?: 'Mutation', createPrepaid: { __typename?: 'Prepaid', id: any, description?: string | null, status: Types.PrepaidStatus, date: CalendarDateString, startDate?: CalendarDateString | null, endDate?: CalendarDateString | null, expenseRecognitionMethod?: Types.ExpenseRecognitionMethod | null, ledgerCoaKey: string, total?: { __typename?: 'Money', amount: string } | null, vendor?: { __typename?: 'Vendor', id: string, name: string } | null } };

export type DeletePrepaidMutationVariables = Types.Exact<{
  input: Types.DeletePrepaidInput;
}>;


export type DeletePrepaidMutation = { __typename?: 'Mutation', deletePrepaid: { __typename?: 'DeletePrepaidResult', success: boolean } };

export type VoidPrepaidMutationVariables = Types.Exact<{
  input: Types.VoidPrepaidInput;
}>;


export type VoidPrepaidMutation = { __typename?: 'Mutation', voidPrepaid: { __typename?: 'Prepaid', id: any, description?: string | null, status: Types.PrepaidStatus, date: CalendarDateString, startDate?: CalendarDateString | null, endDate?: CalendarDateString | null, expenseRecognitionMethod?: Types.ExpenseRecognitionMethod | null, ledgerCoaKey: string, total?: { __typename?: 'Money', amount: string } | null, vendor?: { __typename?: 'Vendor', id: string, name: string } | null } };

export type UpsertPrepaidForBillLineMutationVariables = Types.Exact<{
  input: Types.UpsertPrepaidForBillLineInput;
}>;


export type UpsertPrepaidForBillLineMutation = { __typename?: 'Mutation', upsertPrepaidForBillLine: { __typename?: 'Prepaid', id: any, description?: string | null, status: Types.PrepaidStatus, date: CalendarDateString, startDate?: CalendarDateString | null, endDate?: CalendarDateString | null, expenseRecognitionMethod?: Types.ExpenseRecognitionMethod | null, ledgerCoaKey: string, total?: { __typename?: 'Money', amount: string } | null, vendor?: { __typename?: 'Vendor', id: string, name: string } | null } };

export type UpsertPrepaidForDetailMutationVariables = Types.Exact<{
  input: Types.UpsertPrepaidForDetailInput;
}>;


export type UpsertPrepaidForDetailMutation = { __typename?: 'Mutation', upsertPrepaidForDetail: { __typename?: 'Prepaid', id: any, description?: string | null, status: Types.PrepaidStatus, date: CalendarDateString, startDate?: CalendarDateString | null, endDate?: CalendarDateString | null, expenseRecognitionMethod?: Types.ExpenseRecognitionMethod | null, ledgerCoaKey: string, total?: { __typename?: 'Money', amount: string } | null, vendor?: { __typename?: 'Vendor', id: string, name: string } | null } };

export type UpdatePrepaidMutationVariables = Types.Exact<{
  input: Types.UpdatePrepaidInput;
}>;


export type UpdatePrepaidMutation = { __typename?: 'Mutation', updatePrepaid: { __typename?: 'Prepaid', id: any, description?: string | null, status: Types.PrepaidStatus, date: CalendarDateString, startDate?: CalendarDateString | null, endDate?: CalendarDateString | null, expenseRecognitionMethod?: Types.ExpenseRecognitionMethod | null, ledgerCoaKey: string, total?: { __typename?: 'Money', amount: string } | null, vendor?: { __typename?: 'Vendor', id: string, name: string } | null } };

export type ActivatePrepaidMutationVariables = Types.Exact<{
  id: Types.Scalars['PrepaidID']['input'];
}>;


export type ActivatePrepaidMutation = { __typename?: 'Mutation', activatePrepaid: { __typename?: 'Prepaid', id: any, description?: string | null, status: Types.PrepaidStatus, date: CalendarDateString, startDate?: CalendarDateString | null, endDate?: CalendarDateString | null, expenseRecognitionMethod?: Types.ExpenseRecognitionMethod | null, ledgerCoaKey: string, total?: { __typename?: 'Money', amount: string } | null, vendor?: { __typename?: 'Vendor', id: string, name: string } | null } };

export type GetPrepaidsRollforwardQueryVariables = Types.Exact<{
  input: Types.PrepaidRollforwardDataInput;
}>;


export type GetPrepaidsRollforwardQuery = { __typename?: 'Query', prepaidRollforwardData: { __typename?: 'PrepaidRollforwardDataPaginator', totals: { __typename?: 'PrepaidRollforwardDataTotals', amount: { __typename?: 'Money', amount: string }, opening: { __typename?: 'Money', amount: string }, prepaid: { __typename?: 'Money', amount: string }, closing: { __typename?: 'Money', amount: string }, recognized: { __typename?: 'Money', amount: string }, recognizedEndPeriod: { __typename?: 'PrepaidRollforwardDataPeriod', period: string, total: { __typename?: 'Money', amount: string } } }, coaTotals: Array<{ __typename?: 'PrepaidRollforwardDataByCoa', ledgerCoaKey: string, totals: { __typename?: 'PrepaidRollforwardDataTotals', amount: { __typename?: 'Money', amount: string }, opening: { __typename?: 'Money', amount: string }, prepaid: { __typename?: 'Money', amount: string }, closing: { __typename?: 'Money', amount: string }, recognized: { __typename?: 'Money', amount: string }, recognizedEndPeriod: { __typename?: 'PrepaidRollforwardDataPeriod', period: string, total: { __typename?: 'Money', amount: string } } } } | null>, items: Array<{ __typename?: 'PrepaidRollforwardData', prepaid: { __typename?: 'Prepaid', id: any, description?: string | null, status: Types.PrepaidStatus, date: CalendarDateString, startDate?: CalendarDateString | null, endDate?: CalendarDateString | null, expenseRecognitionMethod?: Types.ExpenseRecognitionMethod | null, ledgerCoaKey: string, total?: { __typename?: 'Money', amount: string } | null, vendor?: { __typename?: 'Vendor', id: string, name: string } | null }, totals: { __typename?: 'PrepaidRollforwardDataTotals', amount: { __typename?: 'Money', amount: string }, opening: { __typename?: 'Money', amount: string }, prepaid: { __typename?: 'Money', amount: string }, closing: { __typename?: 'Money', amount: string }, recognized: { __typename?: 'Money', amount: string }, recognizedEndPeriod: { __typename?: 'PrepaidRollforwardDataPeriod', period: string, total: { __typename?: 'Money', amount: string } } } }> } };

export type ExpenseTransactionForPrepaidFragment = { __typename?: 'Transaction', id: string, date: CalendarDateString, amount: string, descriptor: string, detail: { __typename?: 'TransactionDetail', id: string, vendor?: { __typename?: 'Vendor', id: string, name: string } | null, category: { __typename?: 'GatewayCategory', id?: string | null, permaKey: string } | { __typename?: 'LedgerCategory', id?: string | null, permaKey: string } } };

export type GetExpenseTransactionsForPepaidsQueryVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  filterBy?: Types.InputMaybe<Types.TransactionFilterBy>;
  sortBy?: Types.InputMaybe<Types.TransactionSortOrder>;
  page?: Types.InputMaybe<Types.PageInput>;
}>;


export type GetExpenseTransactionsForPepaidsQuery = { __typename?: 'Query', company?: { __typename?: 'Company', id: string, transactions: { __typename?: 'CompanyTransactionPaginator', totalCount: number, nodes: Array<{ __typename?: 'Transaction', id: string, date: CalendarDateString, amount: string, descriptor: string, detail: { __typename?: 'TransactionDetail', id: string, vendor?: { __typename?: 'Vendor', id: string, name: string } | null, category: { __typename?: 'GatewayCategory', id?: string | null, permaKey: string } | { __typename?: 'LedgerCategory', id?: string | null, permaKey: string } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, total?: number | null } } } | null };

export const PagedPrepaidFragmentDoc = gql`
    fragment pagedPrepaid on Prepaid {
  id
  description
  status
  date
  startDate
  endDate
  expenseRecognitionMethod
  ledgerCoaKey
  total {
    amount
  }
  vendor {
    id
    name
  }
}
    `;
export const PrepaidRollforwardTotalsFragmentDoc = gql`
    fragment prepaidRollforwardTotals on PrepaidRollforwardDataTotals {
  amount {
    amount
  }
  opening {
    amount
  }
  prepaid {
    amount
  }
  closing {
    amount
  }
  recognized {
    amount
  }
  recognizedEndPeriod {
    period
    total {
      amount
    }
  }
}
    `;
export const PrepaidRollforwardByCoaFragmentDoc = gql`
    fragment prepaidRollforwardByCoa on PrepaidRollforwardDataByCoa {
  ledgerCoaKey
  totals {
    ...prepaidRollforwardTotals
  }
}
    ${PrepaidRollforwardTotalsFragmentDoc}`;
export const PrepaidSchedulePreviewItemsFragmentDoc = gql`
    fragment prepaidSchedulePreviewItems on PrepaidExpenseRecognitionSchedulePreviewItems {
  period
  expenseIncurred
  cumulativeExpense
  prepaidExpense
}
    `;
export const ExpenseTransactionForPrepaidFragmentDoc = gql`
    fragment expenseTransactionForPrepaid on Transaction {
  id
  date
  amount
  descriptor
  detail {
    id
    vendor {
      id
      name
    }
    category {
      id
      permaKey
    }
  }
}
    `;
export const GetPrepaidsDocument = gql`
    query getPrepaids($companyId: ID!, $filterBy: PrepaidFilterBy, $sortBy: PrepaidSortOrder, $page: PageInput) {
  company(id: $companyId) {
    id
    prepaids(filterBy: $filterBy, sortBy: $sortBy, page: $page) {
      items {
        ...pagedPrepaid
      }
      pageInfo {
        ...pageInfo
      }
    }
  }
}
    ${PagedPrepaidFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useGetPrepaidsQuery__
 *
 * To run a query within a React component, call `useGetPrepaidsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrepaidsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrepaidsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      filterBy: // value for 'filterBy'
 *      sortBy: // value for 'sortBy'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetPrepaidsQuery(baseOptions: Apollo.QueryHookOptions<GetPrepaidsQuery, GetPrepaidsQueryVariables> & ({ variables: GetPrepaidsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPrepaidsQuery, GetPrepaidsQueryVariables>(GetPrepaidsDocument, options);
      }
export function useGetPrepaidsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPrepaidsQuery, GetPrepaidsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPrepaidsQuery, GetPrepaidsQueryVariables>(GetPrepaidsDocument, options);
        }
export function useGetPrepaidsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPrepaidsQuery, GetPrepaidsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPrepaidsQuery, GetPrepaidsQueryVariables>(GetPrepaidsDocument, options);
        }
export type GetPrepaidsQueryHookResult = ReturnType<typeof useGetPrepaidsQuery>;
export type GetPrepaidsLazyQueryHookResult = ReturnType<typeof useGetPrepaidsLazyQuery>;
export type GetPrepaidsSuspenseQueryHookResult = ReturnType<typeof useGetPrepaidsSuspenseQuery>;
export type GetPrepaidsQueryResult = Apollo.QueryResult<GetPrepaidsQuery, GetPrepaidsQueryVariables>;
export const PrepaidExpenseRecognitionSchedulePreviewDocument = gql`
    query prepaidExpenseRecognitionSchedulePreview($input: PrepaidExpenseRecognitionSchedulePreviewInput!) {
  prepaidExpenseRecognitionSchedulePreview(input: $input) {
    scheduleItems {
      ...prepaidSchedulePreviewItems
    }
  }
}
    ${PrepaidSchedulePreviewItemsFragmentDoc}`;

/**
 * __usePrepaidExpenseRecognitionSchedulePreviewQuery__
 *
 * To run a query within a React component, call `usePrepaidExpenseRecognitionSchedulePreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrepaidExpenseRecognitionSchedulePreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrepaidExpenseRecognitionSchedulePreviewQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePrepaidExpenseRecognitionSchedulePreviewQuery(baseOptions: Apollo.QueryHookOptions<PrepaidExpenseRecognitionSchedulePreviewQuery, PrepaidExpenseRecognitionSchedulePreviewQueryVariables> & ({ variables: PrepaidExpenseRecognitionSchedulePreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrepaidExpenseRecognitionSchedulePreviewQuery, PrepaidExpenseRecognitionSchedulePreviewQueryVariables>(PrepaidExpenseRecognitionSchedulePreviewDocument, options);
      }
export function usePrepaidExpenseRecognitionSchedulePreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrepaidExpenseRecognitionSchedulePreviewQuery, PrepaidExpenseRecognitionSchedulePreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrepaidExpenseRecognitionSchedulePreviewQuery, PrepaidExpenseRecognitionSchedulePreviewQueryVariables>(PrepaidExpenseRecognitionSchedulePreviewDocument, options);
        }
export function usePrepaidExpenseRecognitionSchedulePreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PrepaidExpenseRecognitionSchedulePreviewQuery, PrepaidExpenseRecognitionSchedulePreviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PrepaidExpenseRecognitionSchedulePreviewQuery, PrepaidExpenseRecognitionSchedulePreviewQueryVariables>(PrepaidExpenseRecognitionSchedulePreviewDocument, options);
        }
export type PrepaidExpenseRecognitionSchedulePreviewQueryHookResult = ReturnType<typeof usePrepaidExpenseRecognitionSchedulePreviewQuery>;
export type PrepaidExpenseRecognitionSchedulePreviewLazyQueryHookResult = ReturnType<typeof usePrepaidExpenseRecognitionSchedulePreviewLazyQuery>;
export type PrepaidExpenseRecognitionSchedulePreviewSuspenseQueryHookResult = ReturnType<typeof usePrepaidExpenseRecognitionSchedulePreviewSuspenseQuery>;
export type PrepaidExpenseRecognitionSchedulePreviewQueryResult = Apollo.QueryResult<PrepaidExpenseRecognitionSchedulePreviewQuery, PrepaidExpenseRecognitionSchedulePreviewQueryVariables>;
export const PrepaidExpenseRecognitionSchedulePreviewByCriteriaDocument = gql`
    query prepaidExpenseRecognitionSchedulePreviewByCriteria($input: PrepaidExpenseRecognitionSchedulePreviewByCriteriaInput!) {
  prepaidExpenseRecognitionSchedulePreviewByCriteria(input: $input) {
    scheduleItems {
      ...prepaidSchedulePreviewItems
    }
  }
}
    ${PrepaidSchedulePreviewItemsFragmentDoc}`;

/**
 * __usePrepaidExpenseRecognitionSchedulePreviewByCriteriaQuery__
 *
 * To run a query within a React component, call `usePrepaidExpenseRecognitionSchedulePreviewByCriteriaQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrepaidExpenseRecognitionSchedulePreviewByCriteriaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrepaidExpenseRecognitionSchedulePreviewByCriteriaQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePrepaidExpenseRecognitionSchedulePreviewByCriteriaQuery(baseOptions: Apollo.QueryHookOptions<PrepaidExpenseRecognitionSchedulePreviewByCriteriaQuery, PrepaidExpenseRecognitionSchedulePreviewByCriteriaQueryVariables> & ({ variables: PrepaidExpenseRecognitionSchedulePreviewByCriteriaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrepaidExpenseRecognitionSchedulePreviewByCriteriaQuery, PrepaidExpenseRecognitionSchedulePreviewByCriteriaQueryVariables>(PrepaidExpenseRecognitionSchedulePreviewByCriteriaDocument, options);
      }
export function usePrepaidExpenseRecognitionSchedulePreviewByCriteriaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrepaidExpenseRecognitionSchedulePreviewByCriteriaQuery, PrepaidExpenseRecognitionSchedulePreviewByCriteriaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrepaidExpenseRecognitionSchedulePreviewByCriteriaQuery, PrepaidExpenseRecognitionSchedulePreviewByCriteriaQueryVariables>(PrepaidExpenseRecognitionSchedulePreviewByCriteriaDocument, options);
        }
export function usePrepaidExpenseRecognitionSchedulePreviewByCriteriaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PrepaidExpenseRecognitionSchedulePreviewByCriteriaQuery, PrepaidExpenseRecognitionSchedulePreviewByCriteriaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PrepaidExpenseRecognitionSchedulePreviewByCriteriaQuery, PrepaidExpenseRecognitionSchedulePreviewByCriteriaQueryVariables>(PrepaidExpenseRecognitionSchedulePreviewByCriteriaDocument, options);
        }
export type PrepaidExpenseRecognitionSchedulePreviewByCriteriaQueryHookResult = ReturnType<typeof usePrepaidExpenseRecognitionSchedulePreviewByCriteriaQuery>;
export type PrepaidExpenseRecognitionSchedulePreviewByCriteriaLazyQueryHookResult = ReturnType<typeof usePrepaidExpenseRecognitionSchedulePreviewByCriteriaLazyQuery>;
export type PrepaidExpenseRecognitionSchedulePreviewByCriteriaSuspenseQueryHookResult = ReturnType<typeof usePrepaidExpenseRecognitionSchedulePreviewByCriteriaSuspenseQuery>;
export type PrepaidExpenseRecognitionSchedulePreviewByCriteriaQueryResult = Apollo.QueryResult<PrepaidExpenseRecognitionSchedulePreviewByCriteriaQuery, PrepaidExpenseRecognitionSchedulePreviewByCriteriaQueryVariables>;
export const CreatePrepaidDocument = gql`
    mutation createPrepaid($input: CreatePrepaidInput!) {
  createPrepaid(input: $input) {
    ...pagedPrepaid
  }
}
    ${PagedPrepaidFragmentDoc}`;
export type CreatePrepaidMutationFn = Apollo.MutationFunction<CreatePrepaidMutation, CreatePrepaidMutationVariables>;

/**
 * __useCreatePrepaidMutation__
 *
 * To run a mutation, you first call `useCreatePrepaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePrepaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPrepaidMutation, { data, loading, error }] = useCreatePrepaidMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePrepaidMutation(baseOptions?: Apollo.MutationHookOptions<CreatePrepaidMutation, CreatePrepaidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePrepaidMutation, CreatePrepaidMutationVariables>(CreatePrepaidDocument, options);
      }
export type CreatePrepaidMutationHookResult = ReturnType<typeof useCreatePrepaidMutation>;
export type CreatePrepaidMutationResult = Apollo.MutationResult<CreatePrepaidMutation>;
export type CreatePrepaidMutationOptions = Apollo.BaseMutationOptions<CreatePrepaidMutation, CreatePrepaidMutationVariables>;
export const DeletePrepaidDocument = gql`
    mutation deletePrepaid($input: DeletePrepaidInput!) {
  deletePrepaid(input: $input) {
    success
  }
}
    `;
export type DeletePrepaidMutationFn = Apollo.MutationFunction<DeletePrepaidMutation, DeletePrepaidMutationVariables>;

/**
 * __useDeletePrepaidMutation__
 *
 * To run a mutation, you first call `useDeletePrepaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePrepaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePrepaidMutation, { data, loading, error }] = useDeletePrepaidMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePrepaidMutation(baseOptions?: Apollo.MutationHookOptions<DeletePrepaidMutation, DeletePrepaidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePrepaidMutation, DeletePrepaidMutationVariables>(DeletePrepaidDocument, options);
      }
export type DeletePrepaidMutationHookResult = ReturnType<typeof useDeletePrepaidMutation>;
export type DeletePrepaidMutationResult = Apollo.MutationResult<DeletePrepaidMutation>;
export type DeletePrepaidMutationOptions = Apollo.BaseMutationOptions<DeletePrepaidMutation, DeletePrepaidMutationVariables>;
export const VoidPrepaidDocument = gql`
    mutation voidPrepaid($input: VoidPrepaidInput!) {
  voidPrepaid(input: $input) {
    ...pagedPrepaid
  }
}
    ${PagedPrepaidFragmentDoc}`;
export type VoidPrepaidMutationFn = Apollo.MutationFunction<VoidPrepaidMutation, VoidPrepaidMutationVariables>;

/**
 * __useVoidPrepaidMutation__
 *
 * To run a mutation, you first call `useVoidPrepaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVoidPrepaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [voidPrepaidMutation, { data, loading, error }] = useVoidPrepaidMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVoidPrepaidMutation(baseOptions?: Apollo.MutationHookOptions<VoidPrepaidMutation, VoidPrepaidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VoidPrepaidMutation, VoidPrepaidMutationVariables>(VoidPrepaidDocument, options);
      }
export type VoidPrepaidMutationHookResult = ReturnType<typeof useVoidPrepaidMutation>;
export type VoidPrepaidMutationResult = Apollo.MutationResult<VoidPrepaidMutation>;
export type VoidPrepaidMutationOptions = Apollo.BaseMutationOptions<VoidPrepaidMutation, VoidPrepaidMutationVariables>;
export const UpsertPrepaidForBillLineDocument = gql`
    mutation upsertPrepaidForBillLine($input: UpsertPrepaidForBillLineInput!) {
  upsertPrepaidForBillLine(input: $input) {
    ...pagedPrepaid
  }
}
    ${PagedPrepaidFragmentDoc}`;
export type UpsertPrepaidForBillLineMutationFn = Apollo.MutationFunction<UpsertPrepaidForBillLineMutation, UpsertPrepaidForBillLineMutationVariables>;

/**
 * __useUpsertPrepaidForBillLineMutation__
 *
 * To run a mutation, you first call `useUpsertPrepaidForBillLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPrepaidForBillLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPrepaidForBillLineMutation, { data, loading, error }] = useUpsertPrepaidForBillLineMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertPrepaidForBillLineMutation(baseOptions?: Apollo.MutationHookOptions<UpsertPrepaidForBillLineMutation, UpsertPrepaidForBillLineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertPrepaidForBillLineMutation, UpsertPrepaidForBillLineMutationVariables>(UpsertPrepaidForBillLineDocument, options);
      }
export type UpsertPrepaidForBillLineMutationHookResult = ReturnType<typeof useUpsertPrepaidForBillLineMutation>;
export type UpsertPrepaidForBillLineMutationResult = Apollo.MutationResult<UpsertPrepaidForBillLineMutation>;
export type UpsertPrepaidForBillLineMutationOptions = Apollo.BaseMutationOptions<UpsertPrepaidForBillLineMutation, UpsertPrepaidForBillLineMutationVariables>;
export const UpsertPrepaidForDetailDocument = gql`
    mutation upsertPrepaidForDetail($input: UpsertPrepaidForDetailInput!) {
  upsertPrepaidForDetail(input: $input) {
    ...pagedPrepaid
  }
}
    ${PagedPrepaidFragmentDoc}`;
export type UpsertPrepaidForDetailMutationFn = Apollo.MutationFunction<UpsertPrepaidForDetailMutation, UpsertPrepaidForDetailMutationVariables>;

/**
 * __useUpsertPrepaidForDetailMutation__
 *
 * To run a mutation, you first call `useUpsertPrepaidForDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPrepaidForDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPrepaidForDetailMutation, { data, loading, error }] = useUpsertPrepaidForDetailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertPrepaidForDetailMutation(baseOptions?: Apollo.MutationHookOptions<UpsertPrepaidForDetailMutation, UpsertPrepaidForDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertPrepaidForDetailMutation, UpsertPrepaidForDetailMutationVariables>(UpsertPrepaidForDetailDocument, options);
      }
export type UpsertPrepaidForDetailMutationHookResult = ReturnType<typeof useUpsertPrepaidForDetailMutation>;
export type UpsertPrepaidForDetailMutationResult = Apollo.MutationResult<UpsertPrepaidForDetailMutation>;
export type UpsertPrepaidForDetailMutationOptions = Apollo.BaseMutationOptions<UpsertPrepaidForDetailMutation, UpsertPrepaidForDetailMutationVariables>;
export const UpdatePrepaidDocument = gql`
    mutation updatePrepaid($input: UpdatePrepaidInput!) {
  updatePrepaid(input: $input) {
    ...pagedPrepaid
  }
}
    ${PagedPrepaidFragmentDoc}`;
export type UpdatePrepaidMutationFn = Apollo.MutationFunction<UpdatePrepaidMutation, UpdatePrepaidMutationVariables>;

/**
 * __useUpdatePrepaidMutation__
 *
 * To run a mutation, you first call `useUpdatePrepaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePrepaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePrepaidMutation, { data, loading, error }] = useUpdatePrepaidMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePrepaidMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePrepaidMutation, UpdatePrepaidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePrepaidMutation, UpdatePrepaidMutationVariables>(UpdatePrepaidDocument, options);
      }
export type UpdatePrepaidMutationHookResult = ReturnType<typeof useUpdatePrepaidMutation>;
export type UpdatePrepaidMutationResult = Apollo.MutationResult<UpdatePrepaidMutation>;
export type UpdatePrepaidMutationOptions = Apollo.BaseMutationOptions<UpdatePrepaidMutation, UpdatePrepaidMutationVariables>;
export const ActivatePrepaidDocument = gql`
    mutation activatePrepaid($id: PrepaidID!) {
  activatePrepaid(id: $id) {
    ...pagedPrepaid
  }
}
    ${PagedPrepaidFragmentDoc}`;
export type ActivatePrepaidMutationFn = Apollo.MutationFunction<ActivatePrepaidMutation, ActivatePrepaidMutationVariables>;

/**
 * __useActivatePrepaidMutation__
 *
 * To run a mutation, you first call `useActivatePrepaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivatePrepaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activatePrepaidMutation, { data, loading, error }] = useActivatePrepaidMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActivatePrepaidMutation(baseOptions?: Apollo.MutationHookOptions<ActivatePrepaidMutation, ActivatePrepaidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivatePrepaidMutation, ActivatePrepaidMutationVariables>(ActivatePrepaidDocument, options);
      }
export type ActivatePrepaidMutationHookResult = ReturnType<typeof useActivatePrepaidMutation>;
export type ActivatePrepaidMutationResult = Apollo.MutationResult<ActivatePrepaidMutation>;
export type ActivatePrepaidMutationOptions = Apollo.BaseMutationOptions<ActivatePrepaidMutation, ActivatePrepaidMutationVariables>;
export const GetPrepaidsRollforwardDocument = gql`
    query getPrepaidsRollforward($input: PrepaidRollforwardDataInput!) {
  prepaidRollforwardData(input: $input) {
    totals {
      ...prepaidRollforwardTotals
    }
    coaTotals {
      ...prepaidRollforwardByCoa
    }
    items {
      prepaid {
        ...pagedPrepaid
      }
      totals {
        ...prepaidRollforwardTotals
      }
    }
  }
}
    ${PrepaidRollforwardTotalsFragmentDoc}
${PrepaidRollforwardByCoaFragmentDoc}
${PagedPrepaidFragmentDoc}`;

/**
 * __useGetPrepaidsRollforwardQuery__
 *
 * To run a query within a React component, call `useGetPrepaidsRollforwardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrepaidsRollforwardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrepaidsRollforwardQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPrepaidsRollforwardQuery(baseOptions: Apollo.QueryHookOptions<GetPrepaidsRollforwardQuery, GetPrepaidsRollforwardQueryVariables> & ({ variables: GetPrepaidsRollforwardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPrepaidsRollforwardQuery, GetPrepaidsRollforwardQueryVariables>(GetPrepaidsRollforwardDocument, options);
      }
export function useGetPrepaidsRollforwardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPrepaidsRollforwardQuery, GetPrepaidsRollforwardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPrepaidsRollforwardQuery, GetPrepaidsRollforwardQueryVariables>(GetPrepaidsRollforwardDocument, options);
        }
export function useGetPrepaidsRollforwardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPrepaidsRollforwardQuery, GetPrepaidsRollforwardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPrepaidsRollforwardQuery, GetPrepaidsRollforwardQueryVariables>(GetPrepaidsRollforwardDocument, options);
        }
export type GetPrepaidsRollforwardQueryHookResult = ReturnType<typeof useGetPrepaidsRollforwardQuery>;
export type GetPrepaidsRollforwardLazyQueryHookResult = ReturnType<typeof useGetPrepaidsRollforwardLazyQuery>;
export type GetPrepaidsRollforwardSuspenseQueryHookResult = ReturnType<typeof useGetPrepaidsRollforwardSuspenseQuery>;
export type GetPrepaidsRollforwardQueryResult = Apollo.QueryResult<GetPrepaidsRollforwardQuery, GetPrepaidsRollforwardQueryVariables>;
export const GetExpenseTransactionsForPepaidsDocument = gql`
    query getExpenseTransactionsForPepaids($companyId: ID!, $filterBy: TransactionFilterBy, $sortBy: TransactionSortOrder, $page: PageInput) {
  company(id: $companyId) {
    id
    transactions(filterBy: $filterBy, sortBy: $sortBy, page: $page) {
      totalCount
      nodes {
        ...expenseTransactionForPrepaid
      }
      pageInfo {
        ...pageInfo
      }
    }
  }
}
    ${ExpenseTransactionForPrepaidFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useGetExpenseTransactionsForPepaidsQuery__
 *
 * To run a query within a React component, call `useGetExpenseTransactionsForPepaidsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExpenseTransactionsForPepaidsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExpenseTransactionsForPepaidsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      filterBy: // value for 'filterBy'
 *      sortBy: // value for 'sortBy'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetExpenseTransactionsForPepaidsQuery(baseOptions: Apollo.QueryHookOptions<GetExpenseTransactionsForPepaidsQuery, GetExpenseTransactionsForPepaidsQueryVariables> & ({ variables: GetExpenseTransactionsForPepaidsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExpenseTransactionsForPepaidsQuery, GetExpenseTransactionsForPepaidsQueryVariables>(GetExpenseTransactionsForPepaidsDocument, options);
      }
export function useGetExpenseTransactionsForPepaidsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExpenseTransactionsForPepaidsQuery, GetExpenseTransactionsForPepaidsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExpenseTransactionsForPepaidsQuery, GetExpenseTransactionsForPepaidsQueryVariables>(GetExpenseTransactionsForPepaidsDocument, options);
        }
export function useGetExpenseTransactionsForPepaidsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExpenseTransactionsForPepaidsQuery, GetExpenseTransactionsForPepaidsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExpenseTransactionsForPepaidsQuery, GetExpenseTransactionsForPepaidsQueryVariables>(GetExpenseTransactionsForPepaidsDocument, options);
        }
export type GetExpenseTransactionsForPepaidsQueryHookResult = ReturnType<typeof useGetExpenseTransactionsForPepaidsQuery>;
export type GetExpenseTransactionsForPepaidsLazyQueryHookResult = ReturnType<typeof useGetExpenseTransactionsForPepaidsLazyQuery>;
export type GetExpenseTransactionsForPepaidsSuspenseQueryHookResult = ReturnType<typeof useGetExpenseTransactionsForPepaidsSuspenseQuery>;
export type GetExpenseTransactionsForPepaidsQueryResult = Apollo.QueryResult<GetExpenseTransactionsForPepaidsQuery, GetExpenseTransactionsForPepaidsQueryVariables>;